import React from 'react';
import { Modal, Row, Typography, Button } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import callIntro from '../../../../../../assets/img/callIntro.svg';
import './bookIntroModal.css';

const BookIntroModal = React.memo((props) => {
  const { onDismissModal, visible, country, isLatam } = props;
  const onBookCall = () => {
    let bookUrl = 'https://calendly.com/careerconsultants/turing-welcome-call';
    if (isLatam && country && country.toLowerCase() !== 'brazil') {
      bookUrl = 'https://calendly.com/careerconsultants/turing-welcome-call-esl';
    } else if (country && country.toLowerCase() === 'brazil') {
      bookUrl = 'https://calendly.com/careerconsultants/turing-welcome-call-br';
    }
    // The two links below looks the same, will comment this out for now incase it changes later.
    // else if (region && region.toLowerCase().includes('asia')) {
    //   bookUrl = 'https://calendly.com/careerconsultants/turing-welcome-call'
    // } else if (region && (region.toLowerCase().includes('europe') || region.toLowerCase().includes('africa') || region.toLowerCase().includes('north america'))) {
    //   bookUrl = 'https://calendly.com/careerconsultants/turing-welcome-call'
    // }
    window.open(bookUrl, '_blank');
    if (onDismissModal && typeof onDismissModal === 'function') onDismissModal();
  };
  return (
    <Modal
      className='call-intro-modal'
      footer={null}
      visible={visible}
    >
      <Row type="flex" justify='center'>
        <img src={callIntro} />
      </Row>
      <Row className="call-intro-book-title"><Typography.Text>Book a Welcome Call</Typography.Text></Row>
      <Row className='call-intro-description'><Typography.Text>Do you want to know more about Turing? Let&apos;s talk so you can clear all your questions that you might have including:</Typography.Text></Row>
      <div className='call-intro-description'>• Vetting and selection process</div>
      <div className='call-intro-description'>• How can you get shortlisted for a remote job</div>
      <div className='call-intro-description'>• Importance of Tests</div>
      <div className='call-intro-description'>And more!</div>
      <Row type="flex" justify="end" className='action-btn'>
        <div className='skip-call-btn'><Button onClick={onDismissModal}>Skip for now</Button></div>
        <Button type="primary" onClick={onBookCall}>Book a call</Button>
      </Row>
    </Modal>
  );
});

BookIntroModal.propTypes = {
  onDismissModal: PropTypes.func,
  visible: PropTypes.bool,
  country: PropTypes.string,
  isLatam: PropTypes.bool
};

const mapStateToProps = ({ home }) => {
  return home ? {
    country: home.country,
    isLatam: home.isLATAM,
    region: home.region
  } : {};
};
export default connect(mapStateToProps)(BookIntroModal);
